import React from 'react';
import styles from '../styles/home.scss';
import {EmailIcon} from "./svg/EmailIcon";
import {GitHubIcon} from "./svg/GitHubIcon";
import {LinkedinIcon} from "./svg/LinkedinIcon";
import {LocationIcon} from "./svg/LocationIcon";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';


export const Home = props => {
    return (
        <div className={styles.homeContainer}>
            <div className={styles.infoContainer}>
                <div className={styles.paddingDiv}/>

                <div className={styles.name}>Christopher Bekos</div>
                <div className={styles.profession}>cloud.engineer | fullstack.developer</div>
                <div className={styles.contactContainer}>
                    <EmailIcon className={styles.contactIcons}/>
                    <GitHubIcon className={styles.contactIcons}/>
                    <LinkedinIcon className={styles.contactIcons}/>
                </div>
                <div className={styles.locationContainer}>
                    <LocationIcon className={styles.locationIcon}/>
                    <div className={styles.locationText}>Thessaloniki, Greece</div>
                </div>

                <div className={styles.paddingDiv}/>
            </div>
            <div className={styles.imgContainer}>
                <LazyLoadImage
                    // alt={"profile-image"}
                    src={require('../resources/images/profile.png')}
                    className={styles.profileImg}
                    effect="blur"
                    placeholderSrc={require('../resources/images/profile_small.png')}
                />
            </div>
        </div>
    )
};
